/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_Field_PurchaseInputs */

const en_withdrawal_field_purchase = /** @type {(inputs: Withdrawal_Field_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase`)
};

const pl_withdrawal_field_purchase = /** @type {(inputs: Withdrawal_Field_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakup`)
};

/**
* | output |
* | --- |
* | "Purchase" |
*
* @param {Withdrawal_Field_PurchaseInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_field_purchase = /** @type {((inputs?: Withdrawal_Field_PurchaseInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_Field_PurchaseInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_field_purchase(inputs)
	return en_withdrawal_field_purchase(inputs)
});